module.exports = __webpack_public_path__ + "img/aleph-header.28d7382c.svg";